<template>
  <v-card autofocus @keydown.esc="cancel">
    <v-card-title class="text-h5">
      {{ title }}
    </v-card-title>
    <v-card-subtitle>
      {{ subtitle }}
    </v-card-subtitle>
    <v-card-text>
      {{ message }}
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="warning" outlined @click="cancel">
        キャンセル
      </v-btn>
      <v-btn color="red" outlined @click="confirm">
        削除
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ConfirmDeleteCard',
  props: {
    title: {
      type: String,
      default: '削除確認'
    },
    subtitle: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: 'データを削除してもよろしいですか？'
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
